// ListingActions.jsx
// Action buttons component for edit and delete operations

import React from 'react';
import { styles } from './styles';

// Modern SVG Icons
const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);



const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const MessageIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const ArchiveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

const ListingActions = ({ 
  listingId, 
  listing, 
  onEdit, 
  onDelete, 
  onMarkSold, 
  onViewDetails, 
  onContactBuyer, 
  onArchive 
}) => {
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(listingId);
  };



  const handleMarkSold = (e) => {
    e.stopPropagation();
    onMarkSold(listingId);
  };

  const handleViewDetails = (e) => {
    e.stopPropagation();
    onViewDetails(listingId);
  };

  const handleContactBuyer = (e) => {
    e.stopPropagation();
    onContactBuyer(listingId);
  };

  const handleArchive = (e) => {
    e.stopPropagation();
    onArchive(listingId);
  };

  // Determine if item is sold
  const isSold = listing?.status === 'sold';

  return (
    <div style={styles.actionsContainer}>
      {!isSold ? (
        // Actions for active listings
        <>
          <button
            onClick={handleMarkSold}
            style={styles.soldButton}
            className="listing-action-btn sold-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#16a34a';
              e.currentTarget.style.borderColor = '#16a34a';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(34, 197, 94, 0.3)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#22c55e';
              e.currentTarget.style.borderColor = '#22c55e';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(34, 197, 94, 0.2)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <CheckIcon />
            <span>Mark as Sold</span>
          </button>
          <button
            onClick={handleEdit}
            style={styles.editButton}
            className="listing-action-btn edit-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#CE1126';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.boxShadow = `0 4px 12px rgba(206, 17, 38, 0.3)`;
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.color = '#CE1126';
              e.currentTarget.style.boxShadow = `0 2px 8px rgba(206, 17, 38, 0.2)`;
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <EditIcon />
            <span>Edit</span>
          </button>
          <button
            onClick={handleArchive}
            style={styles.archiveButton}
            className="listing-action-btn archive-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#4b5563';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.borderColor = '#4b5563';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.color = '#6b7280';
              e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <ArchiveIcon />
            <span>Archive</span>
          </button>
        </>
      ) : (
        // Actions for sold listings
        <>
          <button
            onClick={handleViewDetails}
            style={styles.viewButton}
            className="listing-action-btn view-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e5e7eb';
              e.currentTarget.style.borderColor = '#374151';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f9fafb';
              e.currentTarget.style.borderColor = '#6b7280';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <EyeIcon />
            <span>View Sale</span>
          </button>
          <button
            onClick={handleContactBuyer}
            style={styles.contactButton}
            className="listing-action-btn contact-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#9d0d1d';
              e.currentTarget.style.borderColor = '#9d0d1d';
              e.currentTarget.style.boxShadow = `0 4px 12px rgba(206, 17, 38, 0.3)`;
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#CE1126';
              e.currentTarget.style.borderColor = '#CE1126';
              e.currentTarget.style.boxShadow = `0 2px 8px rgba(206, 17, 38, 0.3)`;
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <MessageIcon />
            <span>Contact Buyer</span>
          </button>
          <button
            onClick={handleArchive}
            style={styles.archiveButton}
            className="listing-action-btn archive-btn"
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#4b5563';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.borderColor = '#4b5563';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.color = '#6b7280';
              e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <ArchiveIcon />
            <span>Archive</span>
          </button>
        </>
      )}
    </div>
  );
};

// Simple button animations
const listingActionsStyles = `
  .listing-action-btn:active {
    transform: scale(0.98);
    transition: all 0.1s ease;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.getElementById('listing-actions-styles');
  if (!styleElement) {
    const style = document.createElement('style');
    style.id = 'listing-actions-styles';
    style.textContent = listingActionsStyles;
    document.head.appendChild(style);
  }
}

export default ListingActions;